import { render, staticRenderFns } from "./certificate-file.vue?vue&type=template&id=1b34adb6&"
import script from "./certificate-file.vue?vue&type=script&lang=js&"
export * from "./certificate-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports